/**
 * Tenant (travel agency) branding, loaded at startup from GET /tenant/branding.
 * Exports are live bindings, updated before the app renders.
 */
export const BRAND: {
  tenantId: string | null; name: string; logo: string; email: string; phone: string; address: string; copyright: string;
} = { tenantId: null, name: "", logo: "", email: "", phone: "", address: "", copyright: "" };

const baseUrl = () => String(import.meta.env.VITE_APP_BASE_URL || "").replace(/\/$/, "");

/** Header identifying the tenant: logged-in user's tenant wins, else env, else this site's host. */
export const getTenantHeaders = (userTenantId?: string | null): Record<string, string> => {
  const id = userTenantId || (import.meta.env.VITE_TENANT_ID as string) || "";
  if (id) return { "X-Tenant-ID": id };
  return typeof window !== "undefined" ? { "X-Tenant-Domain": window.location.hostname } : {};
};

export const loadBranding = async (userTenantId?: string | null) => {
  try {
    const res = await fetch(`${baseUrl()}/tenant/branding`, { headers: getTenantHeaders(userTenantId) });
    const b = (await res.json())?.data;
    if (b) {
      Object.assign(BRAND, {
        tenantId: b.id || null,
        name: b.appName || b.name || "",
        logo: b.logoUrl || "",
        email: b.contacts?.email || "",
        phone: b.contacts?.phone || "",
        address: b.contacts?.address || "",
        copyright: b.footer?.copyright || "",
      });
      if (BRAND.name) document.title = BRAND.name;
    }
  } catch (e) {
    console.warn("Branding could not be loaded", e);
  }
  return BRAND;
};
